import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

// load -------------------------------------------------------------
const getAll = async () => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/',
        method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const getSelected = async () => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/selected',
        method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
        throw error;
    })
}

const getAllMccMnc = async () => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/mcc-mnc', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const getCountriesMccMnc = async () => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/countries-mcc-mnc', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

const getHpv2Settings = async () => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/current/settings', method: 'get', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

// update -------------------------------------------------------------
const update = async (data) => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/', method: 'put', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
        throw error;
    })
}

// update Settings -------------------------------------------------------------
const updateHpv2Settings = async (data) => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/settings', method: 'put', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
    })
}

// save -------------------------------------------------------------
const save = async (data) => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response.data);
        throw error;
    })
}

// delete -------------------------------------------------------------
const del = async (uuid) => {
    return axios({
        url: getmainurl() + '/api/v1/position-server/' + uuid, method: 'delete', headers: authHeader()
    }).catch(function (error) {
        console.log(error.response.data);
        throw error;
    })
}

// default export ---------------------------------------------------
const positionServer = {
    getAll,
    getSelected,
    update,
    updateHpv2Settings,
    getAllMccMnc,
    getCountriesMccMnc,
    getHpv2Settings,
    save,
    del
};

export default positionServer;